import { RouterParamType } from "@/model/navModel";
import React, { FC, useEffect } from "react";
import { YhBox } from "@/components/YhBox";
import { Form, Input, Col, Row, } from "antd"
import { useSalesDetailModel } from "../salesDetailModel";

export const FormVal: FC<RouterParamType> = (detailsInfo) => {
    const { getLogOne } = useSalesDetailModel(({ logFormVal }) => [logFormVal]);
    const [form] = Form.useForm();

    useEffect(() => {
        getLogOne().then(res => {
            console.log(res)
            res && form.setFieldsValue(res)
        })
    }, [])

    const formItemLayout = {
        labelCol: {
            span: 9,
        },
        wrapperCol: {
            span: 13,
        },
    }

    return (
        <YhBox title="" style={{ marginBottom: "10px" }}>
            <Form form={form} {...formItemLayout}>
                <div className="process-form-container">
                    <div className="process-left">
                        <div className="process-item">
                            <span className="process-title">1.商检</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="商检日期" name="testTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">2.订舱</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="托运日期" name="consignmentTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="ETD" name="etd">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="ETA" name="eta">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="订舱日期" name="bookingTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="consignmentNote">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">3.装柜</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="装柜完成日期" name="carryTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="carryNote">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>

                    </div>
                    <div className="process-right">
                        <div className="process-item">
                            <span className="process-title">4.报关放行</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="海关放行日期" name="releaseTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="报关单号" name="reportCode">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="报关日期" name="declareTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="releaseNote">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">5.装船</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="实际装船日期" name="shipmentTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="shipmentNote">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">6.提单</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="提单号" name="ladingNum">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="提单日期" name="ladingTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="航次船名" name="flight">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="收回日期" name="backTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="备注" name="ladingNote">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        {/* <div className="process-item">
                            <span className="process-title">7.交单/寄单</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="交单日期" name="presentationTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="交单类型" name="presentationType">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="预计收汇日期" name="certificatesTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="交单银行" name="bank">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">8.清关</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="清关日期" name="clearTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div>
                        <div className="process-item">
                            <span className="process-title">9.入库时间</span>
                            <Row>
                                <Col span={12}>
                                    <Form.Item label="入库日期" name="deliveryTime">
                                        <Input disabled />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </div> */}
                    </div>
                </div>
            </Form>
        </YhBox>
    )
}